import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import '../Style/Login_Signup.css'
import Login_Component from '../Components/Login'
import Signup_Component from '../Components/Signup'
import Verify_Code_Component from '../Components/VerifyCode'

function Login_Signup() {
    const [InLoginPage, SetInLoginPage] = useState(true);
    const [NeedCodeSubmit, SetNeedCodeSubmit] = useState(false)
    const Navigate = useNavigate()

    const ChangeForm = () => {
        SetInLoginPage(!InLoginPage);
    }

    const BackToSignup = () => {
        SetInLoginPage(false)
        SetNeedCodeSubmit(false)
    }

    return (
        <>
            <main>
                <div className='login-signup-section-contianer'>
                    {InLoginPage ? <Login_Component OnFormSwitch={() => {ChangeForm()}} /> : !NeedCodeSubmit ? <Signup_Component OnFormSwitch={() => {ChangeForm()}}/> : null}
                    {NeedCodeSubmit ? <Verify_Code_Component OnFormSwitch={() => {BackToSignup()}} /> : null}
                </div>
            </main>
        </>
    )
}

export default Login_Signup